// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"8":"home-view","277":"cast","353":"movie-details-view","912":"reviews"}[chunkId] || chunkId) + "." + {"8":"a87656e1","277":"4fb1f90d","318":"0d484af2","353":"1d1a0dd9","495":"9cfcb97f","617":"f9dece79","730":"1d310e3d","912":"e4c7bee5"}[chunkId] + ".chunk.js";
};